import { useState } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Banner,
} from "@jotty/ui";
import { tenants } from "~/lib/api";
import { useAuthStore } from "~/lib/auth-store";
export const Route = createFileRoute("/_authed/onboarding/first-meeting")({
  component: FirstMeeting,
});
function FirstMeeting() {
  const navigate = useNavigate(),
    tenant = useAuthStore((s) => s.tenants[0]);
  const [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  async function finish() {
    if (!tenant) return;
    setBusy(true);
    try {
      await tenants.completeOnboarding(tenant.id);
      await useAuthStore.getState().refresh();
      void navigate({ to: "/" });
    } catch {
      setError("Could not finish setup. Please retry.");
    } finally {
      setBusy(false);
    }
  }
  return (
    <Card>
      <CardHeader>
        <CardTitle>You’re ready to take notes</CardTitle>
      </CardHeader>
      <CardBody>
        <p>
          Capture meetings in Jotty for Mac. Start with your rough notes, then
          let Jotty enhance them with meeting context. Calendar connection is
          optional in desktop settings.
        </p>
        <p>
          <a href="jotty://settings/callback">Open Jotty for Mac</a>
        </p>
        {error && <Banner tone="danger">{error}</Banner>}
        <Button disabled={busy || !tenant} onClick={() => void finish()}>
          {busy ? "Finishing…" : "Finish setup"}
        </Button>
      </CardBody>
    </Card>
  );
}
